export default function ImmediateQualifierSection() {
  const greenItems = [
    "Your trip is within 1–14 days and you need a passport fast",
    "Your passport expired and you're traveling soon",
    "You need a new passport and have an upcoming trip",
    "Your passport was lost or stolen before your trip",
    "You're renewing and need it back in days, not weeks",
    "You live far from a passport agency and can't make the trip",
  ];

  const amberItems = [
    "Traveling in less than 48 hours — call immediately, we'll assess",
    "Traveling in less than 24 hours — very urgent, call now",
    "Life-or-death family emergency abroad — special protocols apply",
    "Not sure if your situation qualifies — just call, we'll tell you honestly",
  ];

  return (
    <section id="who-qualifies" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-red-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">Immediate Assessment</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            First — Does Your Situation <span className="text-red-600">Qualify?</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Not every urgent situation is the same. Here's a quick guide — and if you're not sure, just call us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          <div className="bg-green-50 border border-green-200 rounded-lg p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <h3 className="font-bold text-lg text-green-800">We Can Likely Help</h3>
            </div>
            <ul className="space-y-3">
              {greenItems.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-green-900 text-sm">
                  <span className="text-green-500 mt-0.5 flex-shrink-0">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-amber-500 flex items-center justify-center">
                <i className="ri-flashlight-line text-white text-lg"></i>
              </div>
              <h3 className="font-bold text-lg text-amber-800">Call Us First</h3>
            </div>
            <ul className="space-y-3">
              {amberItems.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-amber-900 text-sm">
                  <span className="text-amber-500 mt-0.5 flex-shrink-0 text-base">⚡</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center bg-[#1A365D] rounded-lg py-8 px-6">
          <p className="text-white text-lg md:text-xl font-semibold mb-3">
            Not sure? Call 877-253-0084 — we'll tell you exactly what's possible in 2 minutes.
          </p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-base px-8 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}